import { render, staticRenderFns } from "./Gallery.vue?vue&type=template&id=610bb5f4&scoped=true&"
import script from "./Gallery.vue?vue&type=script&lang=js&"
export * from "./Gallery.vue?vue&type=script&lang=js&"
import style0 from "./Gallery.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./Gallery.vue?vue&type=style&index=1&id=610bb5f4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "610bb5f4",
  null
  
)

export default component.exports